const RELATIONSHIP_STATUSES = {
    single: 'Single',
    married: 'Married',
    civil: 'Civil Partner',
    cohabiting: 'Common Law Partnered / Co-habiting',
    divorced: 'Divorced / Dissolved',
    separated: 'Separated',
    widowed: 'Widowed / Surviving Civil Partner',
};

export const TRANSLATE_RELATIONSHIP_STATUSES = t =>
    Object.keys(RELATIONSHIP_STATUSES).reduce(
        (acc, status) => ({
            ...acc,
            [status]: t(`relationShipStatuses.${status}`),
        }),
        {}
    );

export default RELATIONSHIP_STATUSES;
